// extracted by mini-css-extract-plugin
export const heroImgTextContainer = "index-module--heroImgTextContainer--2ybvm";
export const heroImg = "index-module--heroImg--vKBiC";
export const adRoot = "index-module--adRoot--3s2dE";
export const contentRoot = "index-module--contentRoot--15Dfr";
export const gridContainer = "index-module--gridContainer--3MOEL";
export const gridItem = "index-module--gridItem--O8OXE";
export const img = "index-module--img--3ES0F";
export const tagDate = "index-module--tagDate--24XSm";